import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';


import {
    fetchPromotion,
    fetchAllProducts,
    updatePromotion,
    deletePromotion
} from '../../actions/Product';

class CreatePromotion extends Component {

    constructor(props) {
        super(props);

        const { match, history, location } = props;

        let currentPromotion = null;

        if (match.params.promotionId) {
            currentPromotion = props.promotions[match.params.promotionId]
            if (!currentPromotion) {
                props.fetchPromotion(match.params.promotionId);
            }
        }

        if (!currentPromotion) {
            currentPromotion = this.emptyPromotion();
        }

        this.state = {
            promotion: currentPromotion
        };
    }

    componentDidMount() {
        if (!this.props.products || _.size(this.props.products) === 0) {
            this.props.fetchAllProducts();
        }
    }


    componentWillReceiveProps(nextProps) {
        const { match, history, location } = nextProps;

        if (nextProps.promotions) {

            if (match.params.promotionId) {
                let currentPromotion = nextProps.promotions[match.params.promotionId]

                if (!currentPromotion) {
                    currentPromotion = this.emptyPromotion();
                }

                this.setState({ promotion: currentPromotion });
            }
        }
    }

    // Operation

    submitForm(values) {
        console.log(values);

        console.log(this.state.promotion);
        // const { currentPassword, newPassword } = values;
        // this.props.changePassword({ password: currentPassword, newPassword }, (errorMessage) => {
        //     if (errorMessage) {
        //         this.setState({ hasError: true, errorMessage })
        //     } else {
        //         this.props.history.replace('/settings');
        //     }
        // });
        const { promotion } = this.state;
        const { promotionTh, promotionEn, discount } = values;

        if (promotion.product_id === '') {
            // not selecte, show error
            console.log('show error');
            this.setState({ promotion: { ...promotion, showProductError: true } });
        } else {
            let promotionObject = {
                ...promotion,
                name_th: promotionTh,
                name_en: promotionEn,
                discount_value: discount
            };
        }
    }

    // Render

    renderField(field) {
        const { meta: { touched, error }, input, placeholder, label, value, htmlFor, type, required } = field;
        const className = `form-group input-txt ${touched && error ? 'input-error' : ''}`;

        return (
            <div className={className}>
                <label htmlFor={htmlFor}>{label}</label>
                <input className="form-control" type={type} id={htmlFor} placeholder={placeholder} required={required} {...input} />
                <span className="error-message">{touched ? error : ''}</span>
            </div>
        );
    }

    discountField(field) {
        const { meta: { touched, error }, input, placeholder, label, value, htmlFor, promotion } = field;
        const className = `form-group input-txt ${touched && error ? 'input-error' : ''}`;

        return (
            <div className={className}>
                <label htmlFor={htmlFor}>{label}</label>
                <div>
                    <input
                        type="number"
                        className="form-control"
                        id={htmlFor}
                        placeholder={placeholder}
                        step="0.01"
                        min="0.00"
                        {...input}
                    />
                    <div className="btn-group" role="group">
                        <button
                            type="button"
                            className={`btn bath ${promotion.discount_unit === 'exact' ? 'active' : ''}`}
                            onClick={() => this.onExactClick()}
                        >
                            {'฿'}
                        </button>
                        <button
                            type="button"
                            className={`btn percent ${promotion.discount_unit === 'percent' ? 'active' : ''}`}
                            onClick={() => this.onPercentClick()}
                        >
                            {'%'}
                        </button>
                    </div>
                </div>
                <span className="error-message">{touched ? error : ''}</span>
            </div>
        );
    }

    emptyPromotion() {
        return {
            product_id: '',
            status: 0,
            discount_unit: 'percent',
            showProductError: false
        }
    }

    onProductDropdownClick(product, productId) {
        const promotion = this.state.promotion;
        promotion.product_id = productId;

        this.setState({ promotion: promotion });
    }

    onPercentClick() {
        const promotion = this.state.promotion;
        promotion.discount_unit = 'percent';

        this.setState({ promotion: promotion });
    }

    onExactClick() {
        const promotion = this.state.promotion;
        promotion.discount_unit = 'exact';

        this.setState({ promotion: promotion });
    }


    onStatusChange(value) {
        const promotion = this.state.promotion;
        promotion.status = value;
        this.setState({ promotion: promotion });
    }

    renderProductDropdown() {
        const { promotion } = this.state;
        const { products } = this.props;

        const product = products[promotion.product_id];

        const rows = _.map(products, (product, key) => {
            return (
                <li key={key}>
                    <a
                        className="dropdown-item"
                        onClick={() => this.onProductDropdownClick(product, key)}
                    >
                        {product.name_en}
                    </a>
                </li>
            );
        });

        console.log(promotion);

        const buttonClass = `btn dropdown-toggle form-list selected ${promotion.product_id === '' && promotion.showProductError ? 'input-error' : ''}`;

        return (
            <div className="form-group select-dropdown">
                <label htmlFor="dropdown">Product:</label>
                <div className="form-group dropdown form-dropdown">
                    <button
                        className={buttonClass}
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        {product ? product.name_en : 'Select a Product'}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        {rows}
                    </ul>
                </div>
            </div>
        );
    }

    renderDiscountField() {
        const { promotion } = this.state;

        return (
            <Field
                name="discount"
                label="Discount:"
                placeholder="0.00"
                htmlFor="discount"
                component={this.discountField}
                promotion={promotion}
            />
        );

        // return (
        //     <div className="form-group input-txt">
        //         <Field
        //             name="discount"
        //             label="Discount:"
        //             placeholder="0.00"
        //             htmlFor="discount"
        //             component={this.discountField}
        //             promotion={promotion}
        //         />
        //         {/* <input type="text" className="form-control" id="discount" name="discount" value="0.00" required /> */}

        //         <div className="btn-group" role="group">
        //             <button
        //                 type="button"
        //                 className={`btn bath ${promotion.discount_unit === 'exact' ? 'active' : ''}`}
        //                 onClick={() => this.onExactClick()}
        //             >
        //                 {'฿'}
        //             </button>
        //             <button
        //                 type="button"
        //                 className={`btn percent ${promotion.discount_unit === 'percent' ? 'active' : ''}`}
        //                 onClick={() => this.onPercentClick()}
        //             >
        //                 {'%'}
        //             </button>
        //         </div>
        //     </div>
        // );
    }

    renderStatusOptions(promotion) {
        return (
            <div className="active-choice">
                <div className="form-group radio-btn">
                    <div className="radio radio-green" onClick={() => this.onStatusChange(0)}>
                        <input
                            type="radio"
                            className="ip-active"
                            name="shipped"
                            id="radio1"
                            value="active"
                            checked={promotion.status === 0}
                            onChange={() => { }}
                        />
                        <label htmlFor="radio1" style={{ paddingTop: 2, cursor: 'Pointer' }}>
                            {'Active'}
                        </label>
                    </div>
                    <div className="radio radio-green" onClick={() => this.onStatusChange(1)}>
                        <input
                            type="radio"
                            className="ip-inactive"
                            name="shipped"
                            id="radio2"
                            value="inactive"
                            checked={promotion.status === 1}
                            onChange={() => { }}
                        />
                        <label htmlFor="radio2" style={{ paddingTop: 2, cursor: 'Pointer' }}>
                            {'Inactive'}
                        </label>
                    </div>
                </div>
                <p className="active">
                    {promotion.status === 0 ? 'Display and enable users to use this promotion on website and mobile application' : 'Hide and prevent users from using this promotion on website and mobile application'}
                </p>
            </div>
        );
    }

    render() {
        const { promotion } = this.state;
        const { match, history, location, handleSubmit } = this.props;
        const isNew = match.path === '/promotions/new';

        return (
            <div>
                <div className="container-fluid">
                    <form onSubmit={handleSubmit(this.submitForm.bind(this))}>
                        <div className="form-header">
                            <div className="row">
                                <div className="col close-page-btn">
                                    <Link to={`/promotions`} className="cross-hover">
                                        <img src="/resources/img/ic-x.png" alt="close button" />
                                    </Link>
                                </div>
                                <div className="col-8">
                                    <h3>{`${isNew ? 'New' : 'Edit'} Promotion`}</h3>
                                </div>
                                <div className="col">
                                    <button className="btn button green-btn" type="submit">{isNew ? 'Add Promotion' : 'Save'}</button>
                                </div>
                            </div>
                        </div>
                        <div className="form-body">
                            <div className="form-content edit-promotion">
                                <div className="promotion">
                                    <h5>Promotion</h5>
                                    <Field
                                        name="promotionEn"
                                        label="Promotion Name (English):"
                                        placeholder="Promotion Name (English)"
                                        htmlFor="promotion-en"
                                        component={this.renderField}
                                        type="text"
                                    />
                                    <Field
                                        name="promotionTh"
                                        label="Promotion Name (ไทย):"
                                        placeholder="Promotion Name (ไทย)"
                                        htmlFor="promotion-th"
                                        component={this.renderField}
                                        type="text"
                                    />
                                </div>
                                <div className="divider"></div>
                                <div className="product">
                                    <h5>Product</h5>
                                    {this.renderProductDropdown()}
                                </div>
                                <div className="divider"></div>
                                <div className="discount">
                                    <h5>Discount</h5>
                                    {this.renderDiscountField()}
                                </div>
                                <div className="divider"></div>
                                {this.renderStatusOptions(promotion)}
                            </div>
                            {!isNew ? (
                                <div className="delete-link">
                                    <a onClick={() => this.onDeleteClick()}>Delete this Promotion</a>
                                </div>
                            ) : null}
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

const validate = (values) => {
    console.log(values);

    const errors = {};

    if (!values.promotionEn) {
        errors.promotionEn = 'Promotion name in English is required.'
    }
    if (!values.promotionTh) {
        errors.promotionTh = 'Promotion name in Thai (ไทย) is required.'
    }
    if (!values.discount) {
        errors.discount = 'Discount value is required.'
    }

    return errors;
}

CreatePromotion = reduxForm({
    validate,
    form: 'PromotionForm',
    enableReinitialize: true
})(CreatePromotion);

function mapStateToProps(state) {
    const { promotions, products, isPromotionLoading, isPromotionError, promotionError } = state.product;
    return { promotions, products, isPromotionLoading, isPromotionError, promotionError };
}

CreatePromotion = connect(mapStateToProps, {
    fetchPromotion,
    fetchAllProducts,
    updatePromotion,
    deletePromotion
})(CreatePromotion);

export default CreatePromotion;


// WEBPACK FOOTER //
// ./src/views/promotions/Create.js